module.exports = __webpack_public_path__ + "static/media/roshan3.9732271d.jpg";